<template>
  <div class="d d_xm">
    <headers :goBack="goBack" />
    <template v-if="list">
      <form1 :list="list" :type="1" />
      <div-footer :status="status" :isShow="true" :formId="1" :id="id" />
    </template>

    <template v-else>
      <van-empty description="暂无相关数据" />
    </template>
  </div>
</template>
<script>
import { reactive, toRefs, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { getsubmitData } from "@/service/form";
import { format } from "@/common/js/utils";
import headers from "@/components/Header";
import form1 from "@/components/form/Form1";
// import { Dialog } from "vant";
import divFooter from "@/components/Footer";
export default {
  // divFooter,
  name: "addForm1",
  components: {
    headers,
    divFooter,
    form1,
  },
  beforeRouteEnter(to, from, next) {
    console.log(to.path, from.path);
    next((vm) => {
      // vm 是当前组件的实例
      const zUrl = ["/info/wtg", "info/ytj"];
      if (zUrl.indexOf(from.path) !== -1) {
        vm.isShowTips = true;
      }
    });
  },
  setup() {
    const router = useRouter();
    const route = useRoute();

    const state = reactive({
      isShowTips: false,
      id: null,
      status: null,
      list: {},
    });

    onMounted(async () => {
      const { id, status } = route.query;
      state.status = status;
      const result = await getsubmitData({ dataId: id });
      const { code, data } = result;

      if (code == 10000 && data) {
        const newObj = {};
        for (const i of data.list) {
          newObj[i.fieldCode] = i.value;
        }
        state.list = newObj;
        //   赋值
        Object.assign(state, newObj);
        state.status = data.status;
        state.id = data.id;
        if (state.isShowTips) {
          // tips(data.status);
        }
      }
    });
    const goBack = () => {
      router.go(-1);
    };

    // const tips = (status) => {
    //   let msg = "";
    //   switch (status) {
    //     case 0:
    //       msg = "您提交的信息已提交审核，审核通过后将自动发布，请等待审核结果~";
    //       break;
    //     case 1:
    //       msg = "您提交的信息已通过审核并计入统计结果";

    //       break;
    //     case 2:
    //       msg = "您提交的信息未通过审核，请修改后重新提交";
    //       break;
    //   }
    //   if (msg !== "") {
    //     Dialog.alert({
    //       message: msg,
    //     }).then(() => {});
    //   }
    // };

    return {
      ...toRefs(state),
      format,
      goBack,
    };
  },
};
</script>
<style lang="less" scoped></style>
